<template>
  <div class="home-reports">
    <Row :gutter="8" style="margin-top: 8px">
      <Col>
        <Card shadow>
          <p slot="title">
            <span>所有主机资源情况</span>
          </p>
          <Spin v-if="hyperVisorsGetting" fix></Spin>
          <Alert v-else-if="hyperVisorsError" type="error" show-icon>
            获取主机资源情况失败
            <a style="float: right" v-on:click="getHyperVisors">刷新</a>
          </Alert>
          <Row v-else>
            <Col :lg="8" style="text-align: center">
              <i-circle
                :size="200"
                :trail-width="4"
                :stroke-width="5"
                :percent="(totalHyperVisors.vcpus.used / totalHyperVisors.vcpus.total) * 100 > 100 ? 100 : (totalHyperVisors.vcpus.used / totalHyperVisors.vcpus.total) * 100"
                stroke-linecap="square"
                :stroke-color="(totalHyperVisors.vcpus.used / totalHyperVisors.vcpus.total) * 100 > 80 ? dangerColor : cgColor">
                <div class="demo-Circle-custom">
                  <h3>已用：{{ totalHyperVisors.vcpus.used }}</h3>
                  <p>总共：{{ totalHyperVisors.vcpus.total }}</p>
                  <span>
                    <i>Vcpus</i>
                  </span>
                </div>
              </i-circle>
            </Col>
            <Col :lg="8" style="text-align: center">
              <i-circle
                :size="200"
                :trail-width="4"
                :stroke-width="5"
                :percent="(totalHyperVisors.memory.used / totalHyperVisors.memory.total) * 100 > 100 ? 100 : (totalHyperVisors.memory.used / totalHyperVisors.memory.total) * 100"
                stroke-linecap="square"
                :stroke-color="(totalHyperVisors.memory.used / totalHyperVisors.memory.total) * 100 > 80 ? dangerColor : cgColor">
                <div class="demo-Circle-custom">
                  <h3>已用：{{ (totalHyperVisors.memory.used / 1024).toFixed(1) }}GB</h3>
                  <p>总共：{{ (totalHyperVisors.memory.total / 1024).toFixed(1) }}GB</p>
                  <span>
                <i>内存</i>
              </span>
                </div>
              </i-circle>
            </Col>
            <Col :lg="8" style="text-align: center">
              <i-circle
                :size="200"
                :trail-width="4"
                :stroke-width="5"
                :percent="(totalHyperVisors.disk.used / totalHyperVisors.disk.total) * 100 > 100 ? 100 : (totalHyperVisors.disk.used / totalHyperVisors.disk.total) * 100"
                stroke-linecap="square"
                :stroke-color="(totalHyperVisors.disk.used / totalHyperVisors.disk.total) * 100 > 80 ? dangerColor : cgColor">
                <div class="demo-Circle-custom">
                  <h3>已用：{{ totalHyperVisors.disk.used }}GB</h3>
                  <p>总共：{{ totalHyperVisors.disk.total }}GB</p>
                  <span>
                <i>本地磁盘</i>
              </span>
                </div>
              </i-circle>
            </Col>
          </Row>
        </Card>
      </Col>
      <Col style="margin-top: 8px">
        <Card shadow>
          <p slot="title">
            <span>各主机使用资源情况</span>
          </p>
          <Alert v-if="hyperVisorsError" type="error" show-icon>
            获取主机资源情况失败
            <a style="float: right" v-on:click="getHyperVisors">刷新</a>
          </Alert>
          <Table
            v-else
            size="small"
            :loading="hyperVisorsGetting"
            :data="hyperVisors.data"
            :columns="hyperVisors.columns"></Table>
        </Card>
      </Col>
      <Col style="margin-top: 8px">
        <Card shadow>
          <p slot="title">
            <span>各租户资源使用情况</span>
          </p>
          <Alert v-if="quotas.error" type="error" show-icon>
            获取租户资源使用情况失败
            <a style="float: right" v-on:click="getQuota">刷新</a>
          </Alert>
          <Table
            v-else
            size="small"
            :loading="quotas.loading"
            :data="quotas.data"
            :columns="quotas.columns"></Table>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getPrivateCloudHyperVisorDetailList } from '@/api/private-cloud/hypervisor'
import { getPrivateCloudQuota } from '@/api/private-cloud/quota'

export default {
  name: 'private-cloud',
  data () {
    return {
      hyperVisorsGetting: false,
      hyperVisorsError: false,
      totalHyperVisors: {
        vcpus: {
          used: 0,
          total: 0
        },
        memory: {
          used: 0,
          total: 0
        },
        disk: {
          used: 0,
          total: 0
        }
      },
      hyperVisors: {
        columns: [
          {
            title: '主机名',
            key: 'hypervisor_hostname',
            align: 'center',
            minWidth: 120
          },
          {
            title: '类型',
            key: 'hypervisor_type',
            align: 'center',
            minWidth: 70
          },
          {
            title: 'VCPU（已用）',
            key: 'vcpus_used',
            align: 'center',
            minWidth: 70
          },
          {
            title: 'VCPU（总计）',
            key: 'vcpus',
            align: 'center',
            minWidth: 70
          },
          {
            title: '内存（已用）',
            key: 'memory_mb_used',
            align: 'center',
            minWidth: 70,
            render: (h, params) => {
              if (params.row.memory_mb_used) {
                return h('span', (params.row.memory_mb_used / 1024).toFixed(1) + ' GB')
              }
            }
          },
          {
            title: '内存（总计）',
            key: 'memory_mb',
            align: 'center',
            minWidth: 70,
            render: (h, params) => {
              if (params.row.memory_mb) {
                return h('span', (params.row.memory_mb / 1024).toFixed(1) + ' GB')
              }
            }
          },
          {
            title: '本地存储（已用）',
            key: 'local_gb_used',
            align: 'center',
            minWidth: 70,
            render: (h, params) => {
              if (params.row.local_gb_used) {
                return h('span', params.row.local_gb_used + ' GB')
              }
            }
          },
          {
            title: '本地存储（总计）',
            key: 'local_gb',
            align: 'center',
            minWidth: 70,
            render: (h, params) => {
              if (params.row.local_gb) {
                return h('span', params.row.local_gb + ' GB')
              }
            }
          },
          {
            title: '实例数量',
            key: 'running_vms',
            align: 'center',
            minWidth: 70
          }
        ],
        data: []
      },
      pieOption: {
        title: {
          text: '',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          orient: 'vertical',
          left: 'left',
          data: []
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '60%',
            center: ['50%', '60%'],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                formatter: '{b} {c}'
              }
            }
          }
        ]
      },
      cgColor: '#43a3fb',
      dangerColor: 'red',
      quotas: {
        error: false,
        loading: false,
        columns: [
          {
            title: '租户名',
            key: 'project_name',
            align: 'center',
            minWidth: 120
          },
          {
            title: '实例数量',
            key: 'instances',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              if (params.row.compute_quota) {
                return h('span', params.row.compute_quota.instances.in_use)
              }
            }
          },
          {
            title: 'Vcpus',
            key: 'cores',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              if (params.row.compute_quota) {
                return h('span', params.row.compute_quota.cores.in_use)
              }
            }
          },
          {
            title: '内存',
            key: 'ram',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              if (params.row.compute_quota) {
                return h('span', (params.row.compute_quota.ram.in_use / 1024).toFixed(1) + ' GB')
              }
            }
          },
          {
            title: '云硬盘存储',
            key: 'ram',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              if (params.row.storage_quota) {
                return h('span', params.row.storage_quota.gigabytes.in_use + ' GB')
              }
            }
          }
        ],
        data: []
      }
    }
  },
  created: function () {
    this.getHyperVisors()
    this.getQuota()
  },
  methods: {
    getHyperVisors () {
      this.hyperVisorsGetting = true
      this.hyperVisorsError = false
      getPrivateCloudHyperVisorDetailList().then(res => {
        this.hyperVisors.data = res.data
        this.totalHyperVisors = {
          vcpus: {
            used: 0,
            total: 0
          },
          memory: {
            used: 0,
            total: 0
          },
          disk: {
            used: 0,
            total: 0
          }
        }
        let NameList = ['已用', '剩余']
        let option = JSON.parse(JSON.stringify(this.pieOption))
        option.legend.data = NameList

        for (let i in this.hyperVisors.data) {
          const resource = this.hyperVisors.data[i]
          this.totalHyperVisors.vcpus.used += resource.vcpus_used
          this.totalHyperVisors.vcpus.total += resource.vcpus
          this.totalHyperVisors.memory.used += resource.memory_mb_used
          this.totalHyperVisors.memory.total += resource.memory_mb
          this.totalHyperVisors.disk.used += resource.local_gb_used
          this.totalHyperVisors.disk.total += resource.local_gb
        }
        this.hyperVisorsGetting = false
      }).catch(res => {
        this.hyperVisorsGetting = false
        this.hyperVisorsError = true
        console.error(res.response)
      })
    },
    getQuota () {
      this.quotas.loading = true
      this.quotas.error = false
      getPrivateCloudQuota().then(res => {
        this.quotas.data = res.data
        this.quotas.loading = false
      }).catch(res => {
        this.quotas.loading = false
        this.quotas.error = true
        console.error(res)
      })
    }
  }
}
</script>

<style>
  .private-cloud-quota-progress.ivu-progress-success .ivu-progress-bg,
  .private-cloud-quota-progress.ivu-progress-success .ivu-progress-success-bg {
    background-color: #ed4014
  }
  .private-cloud-quota-progress.ivu-progress-success .ivu-progress-text {
    color: #ed4014
  }
</style>
